import { Component, EventEmitter, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { NzMessageService } from 'ng-zorro-antd/message';
import { NotificationService } from 'src/app/services/notification.service';

@Component({
  selector: 'app-notification-setting',
  templateUrl: './notification-setting.component.html',
  styleUrls: ['./notification-setting.component.less']
})
export class NotificationSettingComponent implements OnInit {
  notificationData:any[]=[];
  constructor(private notificationService:NotificationService,private message:NzMessageService,private translate:TranslateService) { }
  ngOnInit(): void {
    this.getReceiveSettingList();
  }
  includeChannel(notification:any,channel:string):Boolean{
    return notification.channelList?.some((item:any) => item.channel === channel);
  }
  isChannelActive(notification: any, channel: string): boolean {
    if (!notification || !notification.channelList) {
      return false;
    }
  
    const channelItem = notification.channelList.find((item: any) => item.channel === channel);
    return !!channelItem && channelItem.isActive;
  }

  toggleChannel(notification: any, channel: string, checked: EventEmitter<boolean>): void {
    if (!notification || !notification.channelList) {
      return;
    }
  
    const channelItem = notification.channelList.find((item: any) => item.channel === channel);
    if (channelItem) {
      this.notificationService.editReceiveSetting(channelItem.templateConfigId).subscribe(result => {
        const { rtnCode } = result;
        if (rtnCode !== 10000) {
          channelItem.isActive = checked;
         this.message.create(
          'success',
          this.translate.instant('OPERATION_SUCCESS')
        );
        }else{
          this.message.create(
            'error',
            this.translate.instant('OPERATION_FAILED')
          );
          channelItem.isActive = !checked;
        }
      });
    }
  }

  isFirstChannel(bizType:string,notification:any):boolean{
    const firstIndex = this.notificationData.findIndex(notification => notification.bizType === bizType);
    return notification.templateId === this.notificationData[firstIndex].templateId;
  }

  getRowSpanByBizType(bizType:string):number{
    let count = 0;
    for (let i = 0; i < this.notificationData.length; i++) {
      if (this.notificationData[i].bizType === bizType) {
        count++;
      }
    }
  return count;
  }
  
  
  getReceiveSettingList():void{
    this.notificationService.getReceiveSettingList().subscribe(result => {
      const { rtnCode, rtnData } = result;
      if (rtnCode === 10000) {
        this.notificationData = rtnData.reduce((acc:any, curr:any) => {
          const { name, platform, bizType, channel, isActive,templateConfigId,templateId } = curr;
          const existingItem = acc.find((item:any) => item.name === name && item.bizType === bizType);
          
          if (existingItem) {
            existingItem.channelList.push({ channel, isActive,templateConfigId });
          } else {
            acc.push({ name, platform, bizType,templateId, channelList: [{ channel, isActive,templateConfigId }] });
          }
          
          return acc;
        }, []);
        this.notificationData = this.notificationData.sort((a, b) => {
          if (a.bizType < b.bizType) return -1;
          if (a.bizType > b.bizType) return 1;
          return 0;
        });
      }
    });
  }
}
